import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { MantineProvider } from "@mantine/core";
import { App } from "./App.js";
import { AuthPage } from "./AuthPage.js";
import { facetCssVariablesResolver, facetTheme } from "./theme.js";
import "@mantine/core/styles.layer.css";
import "./app.css";

const root = document.getElementById("root");

if (!root) throw new Error("missing #root element");

createRoot(root).render(
  <StrictMode>
    <MantineProvider theme={facetTheme} cssVariablesResolver={facetCssVariablesResolver} defaultColorScheme="light">
      {window.location.pathname === "/login" ? <AuthPage /> : <App />}
    </MantineProvider>
  </StrictMode>,
);
